export const storeTypeNameUI = {
  regular: 'Regular',
  premium: 'Premium',
  custom: 'Site',
  premium_plus: 'Premium Plus',
  skinceuticals: 'SkinCeuticals',
  premium_lite: 'Modern',
  modern_premium: 'Modern Premium',
  modern_premium_plus: 'Modern Premium Plus'
};
